import { useMemo, useState } from "react";
import PageHeader from "@/components/feature/PageHeader";
import ServiceCard from "@/components/feature/cards/ServiceCard";
import {useServiceCatalog} from '@/hooks/useServiceCatalog';

const ALL = "Todos";

export default function Servicios() {
  const services=useServiceCatalog();
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState<string>(ALL);

  const categories = useMemo(() => {
    const unique = Array.from(new Set(services.map((item) => item.category)));
    return [ALL, ...unique];
  }, [services]);

  const filtered = useMemo(() => {
    const term = query.trim().toLowerCase();
    return services.filter((service) => {
      const matchesCategory = category === ALL || service.category === category;
      const matchesQuery =
        !term ||
        service.name.toLowerCase().includes(term) ||
        service.category.toLowerCase().includes(term) ||
        service.description.toLowerCase().includes(term);
      return matchesCategory && matchesQuery;
    });
  }, [query, category, services]);

  return (
    <div className="animate-fade-in">
      <PageHeader title="Servicios" subtitle="Tratamientos ALÉA" backTo="/" />

      <div className="px-5 pt-2">
        <div className="relative">
          <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-foreground-400" />
          <input
            type="search"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Buscar tratamiento"
            className="h-12 w-full rounded-xl border border-background-300 bg-background-50 pl-11 pr-4 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-accent-400"
          />
        </div>

        <div className="no-scrollbar -mx-5 mt-3 flex gap-2 overflow-x-auto px-5 pb-1">
          {categories.map((item) => {
            const isActive = item === category;
            return (
              <button
                key={item}
                type="button"
                onClick={() => setCategory(item)}
                className={`flex-none cursor-pointer whitespace-nowrap rounded-full border px-4 py-2 font-label text-xs font-semibold transition-all duration-200 ${
                  isActive
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-300 bg-background-50 text-foreground-700 hover:border-accent-300"
                }`}
              >
                {item}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-4 px-5">
        {filtered.length ? (
          <div className="grid grid-cols-2 gap-3">
            {filtered.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center gap-2 rounded-2xl border border-background-200 bg-background-100/70 px-5 py-10 text-center">
            <i className="ri-search-eye-line text-3xl text-foreground-400" />
            <p className="font-heading text-sm font-bold text-foreground-950">
              No encontramos tratamientos
            </p>
            <p className="text-xs text-foreground-600">
              Prueba con otra palabra o cambia de categoría.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
